@if (styleType == 'FLEXIBLE') {
<!-- <ul class="nav nav-tabs1 table-nav mb-2" [hidden]="getHideStatus()"> -->
<ul class="custom-tab-container mb-3" [hidden]="getHideStatus()">
  @for (s of segment | keyvalue:returnZero; track s) {
  <!-- <li class=" mb-1 nav-item mr-1">
    <a class="nav-link" [class.error-segment]="segmentError[s.key] == true"
      [ngClass]="{'active': currentSegment==s.value}" (click)="toSelectSegment(s.value)"
      href="javascript:void(0)">{{s.value | titlecase}}</a>
  </li> -->
  <!-- <li class="mb-1 nav-item mr-1" [ngStyle]="{
            'background-color': currentSegment == s.value ? theme_color : 'transparent',
            'border': '1px solid ' + theme_color,
            'border-radius': '5px'
          }">
    <a class="nav-link" [class.error-segment]="segmentError[s.key] == true"
      [ngClass]="{'active': currentSegment == s.value}" (click)="toSelectSegment(s.value)" href="javascript:void(0)"
      [ngStyle]="{
             'color': currentSegment == s.value ? '#fff' : theme_color
           }">
      {{ s.value | titlecase }}
    </a>
  </li> -->
  <li>
    <a (click)="toSelectSegment(s.value)" [class.active]="currentSegment === s.value" href="javascript:void(0)">
      {{ s.value | titlecase }}
    </a>
  </li>
  }
</ul>
} @else if(styleType=='VERTICAL') {
<!-- <ul class="nav nav-tabs-style-2 mt-3"> -->
<ul class="list-group w-100 border overflow-hidden text-left" style="width: 17.5%;">
  @for (m of segment|keyvalue:returnZero; track m) {
  <!-- <li class="list-unstyled border-bottom list-group-flush ">
    <a (click)="toSelectSegment(m.value)" class="list-group-item list-group-side"
      [ngClass]="{'active': currentSegment == m.value}" [attr.tittle]="m?.value">
      <span>{{m?.value}}</span></a>
  </li> -->
  <li class="list-unstyled border-bottom list-group-flush" (mouseenter)="hoveredSegment = m.value"
    (mouseleave)="hoveredSegment = null" [ngStyle]="{
      'transition': 'all 0.3s ease'
    }">
    <a (click)="toSelectSegment(m.value)" class="list-group-item list-group-side"
      [ngClass]="{'active': currentSegment == m.value}" [ngStyle]="{
       'background-color': hoveredSegment == m.value ? '#fff' :
                           (currentSegment == m.value ? theme_color : 'transparent'),
       'color': hoveredSegment == m.value ? theme_color :
                 (currentSegment == m.value ? '#fff' : 'black'),
       'font-weight': currentSegment == m.value ? 'bold' : 'normal',
       'border': '1px ' + theme_color,
       'border-radius': '5px',
       'box-shadow': hoveredSegment == m.value ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
       'transform': hoveredSegment == m.value ? 'scale(1.03)' : 'scale(1)',
       'transition': 'all 0.3s ease'
     }">
      <span>{{ m?.value }}</span>
    </a>
  </li>

  }
  <!-- <hr class="divider" /> -->
  <!-- </ul> -->
</ul>
} @else {
<ul class="nav nav-tabs-style-2 mt-3">
  @for (s of segment | keyvalue:returnZero; track s) {
  <!-- <li class=" mb-1 nav-item mr-1">
    <a class="nav-link" [class.error-segment]="segmentError[s.key] == true"
      [ngClass]="{'active': currentSegment==s.value}" (click)="toSelectSegment(s.value)"
      href="javascript:void(0)">{{s?.value | titlecase}}</a>
  </li> -->
  <li class="nav-item mr-1" [ngStyle]="{
          'border-bottom': currentSegment == s.value ? '2px solid ' + theme_color : '2px solid transparent',
          'padding-bottom': '4px'
        }">
    <a class="nav-link" [class.error-segment]="segmentError[s.key] == true"
      [ngClass]="{'active': currentSegment == s.value}" (click)="toSelectSegment(s.value)" href="javascript:void(0)"
      [ngStyle]="{
           'color': currentSegment == s.value ? theme_color : '#000',
           'font-weight': currentSegment == s.value ? '600' : 'normal'
         }">
      {{ s?.value | titlecase }}
    </a>
  </li>
  }
</ul>
}
@if (tabBody) {
<div class="tab-content mt-0">
  <div class="tab-pane show active">
    <!-- <div class="card"> -->
    <div class="body">
      <ng-container [ngTemplateOutlet]="tabBody"
        [ngTemplateOutletContext]="{active:currentSegment,is_visited : this.segmentVisited[currentSegment] || false,visited : segmentVisited,activeKey:currentKey}"></ng-container>
    </div>
    <!-- </div> -->
  </div>
</div>
}
<!-- <modify-head-info [bsModalRef]="bsModalRef" [getApiApprove]="approveRequest" #tabModify [modifyData]="modifyData"
[data]="data" [module]="module" [type]="type"></modify-head-info> -->
<ng-template pTemplate="tabFooter" #tabFooter>
  @if (type == 'MODIFICATION_APPROVE') {
  <!-- <ng-container [ngTemplateOutlet]="tabModify?.modifyFooter"></ng-container> -->
  } @else {
  @if (isSubmitted) {
  <div class="col-md-12 mb-2 text-center">
    @if (checkAllError()) {
    <span class="error">Few field not be valid</span>
    }
  </div>
  }
  <div class="col-md-12 text-center">
    <div class="btn-group btn-group-lg">
      @if ((type=='SUBMIT' || type=='MODIFICATION_SUBMIT') && !+data?.modify_request) {
      @if (!isFirstSegment()) {
      <button [disabled]="disabledBtn" (click)="prevSegment()" type="button" class="btn btn-primary mr-2">Prev</button>
      }
      @if (showSubmit && isLastSegment()) {
      <button noDoubleClick [disabled]="disabledBtn || loading || checkAllError()" type="button" (click)="onSubmit()"
        class="btn btn-primary ">
        @if (loading) {
        <i class="pi pi-spin pi-spinner"></i>
        }{{ loading ? 'Saving...' : 'Submit'}}
      </button>
      }
      @if (!isLastSegment()) {
      <button [disabled]="disabledBtn || checkSegmentStatus()" (click)="nextSegment()" type="button"
        class="btn btn-primary mr-1">Save & Next</button>
      }
      }
      <button [disabled]="loading" (click)="close(false)" type="button" class="btn btn-danger ml-2">Cancel</button>
    </div>
  </div>
  }
</ng-template>